import { useState, useEffect } from "react";
import { Form, Row, Col, Input, Image, Typography, Button, Checkbox, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { TFunction } from 'types';
import useForgotPasswordPage from "./useForgotPassword";
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function ForgotPassword () {

  const {
    isResettingPassword,
    resetPassword,
    resetPasswordData,
    hasResetPassword,
    failedResettingPassword,
  } = useForgotPasswordPage();

  const [form] = Form.useForm();

  const { t }: TFunction = useTranslation();

  const onFinish = (values: any) => {

    resetPassword(values);
        
  };

  const renderResetPasswordForm = () => {

      return (
        <>
          <Col 
            xs={24}
            // style={{mar}}
          >
            <Typography.Title level={1} style={{ textAlign: 'center' }}>
              {t('ResetPassword')}
            </Typography.Title>
            <Form
              form={form}
              layout="vertical"
              style={{ fontSize: 18 }}
              onFinish={onFinish}
              validateTrigger="onChange"
            >
              <Form.Item
                // label={t('Email')}
                name="registeredEmail"
                style={{ 
                  fontSize: 18,
                }}
                rules={[
                  {
                    required: true,
                    validator: async (_, value) => {

                      if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {

                        return Promise.reject(new Error(`${t('RequireAValidEmail')}`));
                
                      }

                      if (!value) {
            
                        return Promise.reject(new Error(`${t('EmailIsRequired')}`));
            
                      }
                      
                    },
                  },
                ]}
              >
                <Input
                  placeholder={t('Email')}
                  size="large"
                />
              </Form.Item>
              <Form.Item>
                <Button
                  disabled={false}
                  type="primary"
                  size="large"
                  style={{
                    width: '100%',
                    fontSize: 14,
                    backgroundColor: '#ff6b3d',
                    height: 46,
                  }}
                  onClick={ async (e) => {

                    e.preventDefault();

                    form.submit();

                  }}
                >
                  {t('ResetPassword')}
                </Button>
              </Form.Item>
            </Form>
          </Col>
          <Col 
            xs={24}
            style={{
              textAlign: 'center',
              marginTop: -10,
            }}
          >
            <Typography.Text style={{textAlign: 'center', marginTop: -20}}><a href="/">{t('BackToLogin')}</a></Typography.Text>
          </Col>
        </>
      );
  }

  const renderSuccess = () => {

    return (
      <>
        <Col 
          xs={24}
          style={{
            textAlign: 'center',
          }}
        >
          <Typography.Title level={1} style={{ textAlign: 'center' }}>
            {t('Done!')}
          </Typography.Title>
          <Typography.Text style={{ textAlign: 'center' }}>{t('CheckYourEmail')}</Typography.Text>
          <br />
          {/* <Button
            type="primary"
            href="/"
            style={{
              textAlign: 'center',
              marginTop: 20,
              padding: 20,
              fontSize: 18,
            }}
          >
            {t('BackToLogin')}
          </Button> */}
        </Col>
      </>
    );

  }

  return (
    <>
      <Row
        style={{
          width: 320,
        }}
      >
        {hasResetPassword ? renderSuccess() : renderResetPasswordForm()}
      </Row>
    </>
  )

}